const baseURL = "https://paullab.co.kr/images/10000hours/";

export const title = `${baseURL}title.png`;
export const clock = `${baseURL}clock.png`;
export const quotes = `${baseURL}quotes.png`;
export const click = `${baseURL}click.png`;
export const licat = `${baseURL}licat.png`;
export const loading = `${baseURL}loading.png`;
export const logo = `${baseURL}logo.png`;
